// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LmPcQ","comment":"styles_comment__2AM56"};